import { IconProps } from 'interfaces';

const Bed = ({ className = '~w-4/5 ~h-4/5' }: IconProps) => {
  return (
    <svg
      viewBox='0 0 45 45'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'
    >
      <path
        d='M3.75 6.5625V38.4375'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M41.25 15.9375V38.4375'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.75 15.9375L11.25 19.6875H41.25'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.75 29.0625H11.25M41.25 29.0625H35.625'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.25 19.6875V30.9375C11.25 34.0401 11.8975 34.6875 15 34.6875H31.875C34.9776 34.6875 35.625 34.0401 35.625 30.9375V19.6875'
        fill='#E88800'
      />
      <path
        d='M11.25 19.6875V30.9375C11.25 34.0401 11.8975 34.6875 15 34.6875H31.875C34.9776 34.6875 35.625 34.0401 35.625 30.9375V19.6875'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.7755 19.6875C12.926 18.8925 13.1629 18.0609 13.1169 17.2446C13.0489 16.038 12.4443 14.9367 11.487 14.2757C11.109 14.0146 10.275 13.7482 9.39877 13.5205C8.12025 13.1882 7.48099 13.022 6.73391 13.1933C6.20327 13.315 5.74234 13.5973 5.08341 14.1015C5.01081 14.157 4.97451 14.1848 4.91792 14.2317C4.47056 14.6027 4.07392 15.1392 3.85035 15.6756C3.82207 15.7435 3.79804 15.8082 3.75 15.9375'
        stroke='#E88800'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Bed;
